import './style.scss';
import { useEffect, useState } from 'react';
import DefaultGroupIcon from '../../../assets/icons/defaultGroupIcon.svg';
import { Link } from 'react-router-dom';

function MenuItem({ uid, school }) {
  const [expanded, setExpanded] = useState(false);
  const [rendered, setRendered] = useState(false);

  useEffect(() => {
    const checkbox = document.getElementById(`s${school.id}`);
    const root = document.querySelector(':root');
    root.style.setProperty(
      '--expanded-item-height',
      school?.groups.length > 2 ? '23.5rem' : '19.25rem'
    );
    if (uid === 0 && !expanded && !rendered) {
      checkbox.checked = true;
      setRendered(true);
      setExpanded(true);
    }
  }, [uid, school, expanded, rendered]);

  return (
    <>
      <input
        type='radio'
        id={'s' + school.id}
        name='schoolRadio'
        checked={expanded}
        onChange={({ target }) => setExpanded(target.checked)}
      />
      <div className='school'>
        <label
          htmlFor={'s' + school.id.toString()}
          className='school__expand expand'>
          <span className='material-symbols-rounded expand__icon'>
            expand_more
          </span>
        </label>
        <div className='school__info info'>
          <div className='info__field field'>
            <div className='field__icon icon'>
              <span className='material-symbols-rounded icon__img'>school</span>
            </div>
            <span className='field__title'>Comuna</span>
            <span className='field__value'>{school?.municipality?.name}</span>
          </div>
          <div className='info__field field'>
            <div className='field__icon icon'>
              <span className='material-symbols-rounded  icon__img'>
                description
              </span>
            </div>
            <span className='field__title'>Tipo de Recurso</span>
            <span className='field__value'>{school?.resource?.name}</span>
          </div>
          <div className='info__field field'>
            <div className='field__icon icon'>
              <span className='material-symbols-rounded icon__img icon__img--clip'>
                attach_file
              </span>
            </div>
            <span className='field__title'>Código de la escuela</span>
            <span className='field__value'>{school?.code}</span>
          </div>
        </div>
        <div className='school__groups groups'>
          <div className='groups__field field'>
            <div className='field__icon icon'>
              <span className='material-symbols-rounded icon__img'>group</span>
            </div>
            <span className='field__title'>Grupos</span>
          </div>
          <div className='groups__content wrapper'>
            {school?.groups.length > 0 &&
              school?.groups.map(group => (
                <Link
                  to='/escuelas/grupo'
                  state={{ school, group }}
                  key={group.id}
                  className='wrapper__item item'>
                  <img
                    className='item__icon'
                    src={DefaultGroupIcon}
                    alt='Group_Icon'
                  />
                  <span className='item__name'>{group.code}</span>
                  <span className='material-symbols-rounded item__go'>
                    navigate_next
                  </span>
                </Link>
              ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default MenuItem;